import React from 'react';
import usePageTitle from '../hooks/usePageTitle';
import Header from '../components/Header';
import Hero from '../components/Hero';
import About from '../components/About';
import Services from '../components/Services';
import Products from '../components/Products';
import Partners from '../components/Partners';
import Contact from '../components/Contact';
import Footer from '../components/Footer';

const Home = () => {
  usePageTitle('Home');

  return (
    <div className="home-page">
      <Header />
      <Hero />
      <About />
      <Services />
      <Products />
      <Partners />
      <Contact />
      <Footer />
    </div>
  );
};

export default Home;